import DentistConfirmedOfferPage from './ConfirmedOfferPage';

export default DentistConfirmedOfferPage;